import React from "react";
import filter_icon from "../../img/filter_icon.png";
import dropdown_icon from "../../img/dropdown_icon.png";
import Table from "../Table";

export default function Queries() {
  return (
    <>
      {/* <header
        style={{ backgroundColor: "#111a39" }}
        className="text-white text-lg font-medium p-4 px-8"
      >
        <div className="flex flex-col md:flex-row justify-between items-center">
          <img
            src={unologo}
            alt="Logo"
            className="h-10 mb-4 md:mb-0 cursor-pointer"
          />
          <nav>
            <ul className="flex flex-col md:flex-row gap-4 md:gap-16">
              <li>
                <a href="/" className="hover:text-gray-400">
                  Dashboard
                </a>
              </li>
              <li>
                <a href="/queries" className="hover:text-gray-400">
                  Queries
                </a>
              </li>
              <li>
                <a href="/settings" className="hover:text-gray-400">
                  Settings
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header> */}

      <div className="home px-8 min-h-screen">
        <div className="flex flex-col md:flex-row justify-between pt-4">
          <h3 className="text-white font-semibold p-2">
            Query Submission History
          </h3>
          <div
            style={{ background: "#111A39" }}
            className="flex items-center text-white font-bold py-2 px-5 rounded-[10px]"
          >
            <div
              style={{ borderRight: "0.5px solid #6A7083" }}
              className="cursor-pointer"
            >
              <img src={filter_icon} alt="left-icon" className="mr-2" />
            </div>
            <span className="mx-2 cursor-pointer">Filters</span>
            <img
              src={dropdown_icon}
              alt="Right Icon"
              className="cursor-pointer"
            />
          </div>
        </div>

        <div className="pt-4 pb-4">
          <div className="relative flex flex-col w-full h-full rounded-[16px]">
            <div className="rounded-tl-[16px] rounded-tr-[16px] overflow-x-auto">
              {/* <Table /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
